<template>
    <div class="flex flex-col h-full items-center justify-center lg:px-0 lg:py-0 px-4 py-10">
        <h4 class="text-center m-y-md md:w-1/2 w-full">{{ $t('welcome.heading', { name: user.first_name }) }}</h4>

        <p v-if="userOwnsOrganization" class="md:w-2/3 pb-6 text-center w-full"
            v-html="$t('welcome.owner_message', {
                organization: user.organization.name,
                emphasizedOpen: '<span class=&quot;font-semibold&quot;>',
                emphasizedClose: '</span>'
            })">
        </p>
        <p v-else class="md:w-2/3 pb-6 text-center w-full"
            v-html="$t('welcome.member_message', {
                organization: user.organization.name,
                emphasizedOpen: '<span class=&quot;font-semibold&quot;>',
                emphasizedClose: '</span>'
            })">
        </p>

        <div class="md:w-1/4 pb-10 w-1/2">
            <svg-celebration></svg-celebration>
        </div>

        <div class="pt-2 w-2/3">
            <button @click="goToDashboard" class="btn btn-block btn-primary" type="button">{{ $t('welcome.action') }}</button>
        </div>

        <p class="pt-12 text-center">
            {{ $t('welcome.logout_line') }}
            <a @click="logout" href="javascript:;">{{ $t('auth.logout') }}</a>
        </p>
    </div>
</template>

<script>
import VueConfetti from 'vue-confetti';
import SvgCelebration from '../svg/celebration.vue';

export default {
    components: {
        'svg-celebration': SvgCelebration,
    },

    props: {
        user: Object,
    },

    data() {
        return {
            form: new Form({}),
        };
    },

    computed: {
        userOwnsOrganization() {
            return this.user.id === this.user.organization.owner_id;
        },
    },

    created() {
        this.startConfetti();
    },

    methods: {
        startConfetti() {
            this.$confetti.start({
                defaultSize: 7,
                particlesPerFrame: 0.33,
            });
        },

        goToDashboard() {
            axios.post('/welcome/proceed')
                .then(() => window.location.href = '/dashboard')
                .catch(() => {
                    window.toastr.clear();
                    window.toastr.error(this.$t('globals.unexpected_error'));
                });
        },

        logout() {
            Globals.post('/logout', this.form)
                .then(() => window.location.href = '/')
                .catch(() => {});
        },
    },
};
</script>
